<!-- eslint-disable max-len -->
<template>
  <div>
    <Card title="Song Management">
      <template v-slot:body>
        <div class="pb-3 flex justify-between items-center w-full">
          <div class="flex flex-col items-center w-full">
            <el-row class="w-full pb-3" :gutter="10">
              <el-col :span="8">
                <el-input placeholder="search album name" v-model="filters" @change="searchMusic" ></el-input>
              </el-col>
              <el-col v-if="!isArtist" :span="8" >
                <el-input placeholder="search artist name" v-model="filterName" @change="searchMusic" ></el-input>
              </el-col>
              <el-col v-if="!isArtist" :span="4" class="flex flex-row" >
                <Button @clicked="searchMusic" label="Apply"/>
                <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="resetMusic" /></button>
              </el-col>

            </el-row>
            <el-row class="w-full pb-3" :gutter="10">
              <el-col v-if="!isArtist" :span="24" class="flex flex-row gap-3" >
                <div @click="filterStatus = 0" class="md:w-50 ">
                  <div v-bind:class="filterStatus == 0? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                    <p class="m-auto text-xs font-medium">
                      Waiting For Review ({{countWaitingForReview}})
                    </p>
                  </div>
                </div>
                <div @click="filterStatus = 1" class="md:w-40 ">
                  <div v-bind:class="filterStatus == 1? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                    <p class="m-auto text-xs font-medium">
                      Under Review ({{countUnderReview}})
                    </p>
                  </div>
                </div>
                <div @click="filterStatus = 2" class="md:w-40 ">
                  <div v-bind:class="filterStatus == 2? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                    <p class="m-auto text-xs font-medium">
                      Approved ({{countApproved}})
                    </p>
                  </div>
                </div>
                <div @click="filterStatus = 3" class="md:w-40 ">
                  <div v-bind:class="filterStatus == 3? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                    <p class="m-auto text-xs font-medium ">
                      Rejected ({{countRejected}})
                    </p>
                  </div>
                </div>
                <div @click="filterStatus = 4" class="md:w-40 ">
                  <div v-bind:class="filterStatus == 4? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                    <p class="m-auto text-xs font-medium ">
                      Published ({{countPublished}})
                    </p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <data-tables-server ref="tableSong" class="song-management" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [6] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom" :width="title.prop.width" >
          </el-table-column>
          <el-table-column v-if="!isArtist && filterStatus!==2 && filterStatus!==3" label="Elapsed Day" width="130px" >
            <template slot-scope="scope">
              {{ scope.row.elapsed_day }}
            </template>
          </el-table-column>
          <el-table-column v-if="!isArtist && filterStatus==3" label="Note" width="80px" >
            <template slot-scope="scope">
              <button @click="viewNote(scope.row)" class="p-2 mr-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
              </button>
            </template>
          </el-table-column>
          <el-table-column v-if="!isArtist" label="Song" width="250px" >
            <template slot-scope="scope">
              <audio controls :src="scope.row.file" :id="'audioPlayer'+scope.row.id" class="audio-player" style="width: 240px;" controlsList="nodownload" type="audio/mp3" preload="none" >
                Audio tag not supported
              </audio>
            </template>
          </el-table-column>
          <el-table-column v-if="isArtist || isRecruitment || isFinance" label="Publish" class="text-center" width="120px" >
            <template slot-scope="scope">
              {{ scope.row.published ? 'Published' : 'Not Published' }}
            </template>
          </el-table-column>
          <el-table-column v-if="(isAdmin || isSuperAdmin || isOps || isRecruitment) && filterStatus!==0 && filterStatus!==1 && filterStatus!==3" label="Publish" class="text-center" width="100px" fixed="right">
            <template slot-scope="scope">
              <label
                :for="'toogle'+scope.row.id"
                class="flex items-center"
                :class="isEligiblePublished(scope.row)? 'cursor-pointer' : 'cursor-not-allowed'"
                style="height: 50px;"
              >
                <!-- toggle -->
                <div class="relative m-auto">
                  <!-- input -->
                  <input
                    :id="'toogle'+scope.row.id"
                    type="checkbox" v-model="scope.row.published"
                    @change="submitPublished(scope.row)"
                    :disabled="!isEligiblePublished(scope.row)"
                    class="hidden"
                  />
                  <!-- line -->
                  <div
                    class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                  ></div>
                  <!-- dot -->
                  <div
                    class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                  ></div>
                </div>
                <!-- label -->
              </label>
            </template>
          </el-table-column>
          <el-table-column v-if="isArtist" label="Album Only" class="text-center" width="120px" fixed="right">
            <template slot-scope="scope">
              <label
                :for="'toogle'+scope.row.id"
                class="flex items-center"
                style="height: 50px;"
              >
                <!-- toggle -->
                <div class="relative m-auto">
                  <!-- input -->
                  <input
                    :id="'toogle'+scope.row.id"
                    type="checkbox" v-model="scope.row.is_album_only"
                    @change="changeAlbumOnly(scope.row, scope.row.is_album_only)"
                    class="hidden"
                  />
                  <!-- line -->
                  <div
                    class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                  ></div>
                  <!-- dot -->
                  <div
                    class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                  ></div>
                </div>
                <!-- label -->
              </label>
            </template>
          </el-table-column>
          <el-table-column v-if="(isArtist || ((isAdmin || isSuperAdmin || isOps || isReviewer)))" label="Actions" align="right"  width="200px" fixed="right">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip v-if="isArtist" label="Detail" :position="'is-left'">
                  <button  @click="detail($event,scope.row)" class="p-2 w-8 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="isArtist" label="Edit" :position="'is-left'">
                  <button  @click="edit($event, scope.row)" class="p-2 w-8 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="!isOps && !isReviewer && !isArtist && scope.row.canDelete" label="Delete" :position="'is-left'">
                  <button  @click="deleteSong($event, scope.row)"  class="w-8 mr-2 p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="(isAdmin || isSuperAdmin || isOps || isReviewer) && isEligibleUnderReview(scope.row)" label="Set Under Review" :position="'is-left'">
                  <button  @click="submitUnderReview($event, scope.row)" class="p-2 w-8 mr-2 rounded bg-purple-400 hover:bg-purple-500 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'file-alt']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="(isAdmin || isSuperAdmin || isOps || isReviewer) && isEligibleApproved(scope.row)" label="Approve" :position="'is-left'">
                  <button  @click="submitApproved($event, scope.row)" class="p-2 mr-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'check']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="(isAdmin || isSuperAdmin || isOps || isReviewer) && isEligibleRejected(scope.row)" label="Reject" :position="'is-left'">
                  <button  @click="showingRejectModal($event, scope.row)" class="p-2 w-8 rounded bg-red-700 hover:bg-red-800 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'times']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="(isAdmin || isSuperAdmin || isOps || isReviewer) && scope.row.statusCode==2" label="Add Tags" :position="'is-left'">
                  <button  @click="addTags(scope.row)" class="p-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'tags']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialog
      ref="addSongDetail"
      :isShowingModal="isShowingModal"
      :isLoading="isLoading"
      :error="isError"
      title="Song Details"
      @toggleModal="isShowingModal = !isShowingModal"
      @save="submit()" >
      <template slot="body" >
        <AddSong ref="addSongContent" @on-submit-song="onSubmitSong" :toggle-reset="isShowingModal"  :musicverse-cut="getUser.musicverse_cut" :artist-cut="getUser.artist_cut"></AddSong>
      </template>
    </ModalDialog>
    <ModalDialog
      ref="editSongDetail"
      :isShowingModal="isShowingModalEditSong"
      labelSubmit="Save"
      :isLoading="isLoading"
      :error="isError"
      title="Edit Song Details"
      @toggleModal="isShowingModalEditSong = !isShowingModalEditSong"
      @save="submitEdit()" >
      <template slot="body" >
        <EditSong ref="editSongContent" @on-edit-song="onSubmitEditSong" :toggle-reset="isShowingModalEditSong" :song="song"  :musicverse-cut="getUser.musicverse_cut" :artist-cut="getUser.artist_cut"></EditSong>
      </template>
    </ModalDialog>
    <ModalDialogDetail
      ref="detailSong"
      :isShowingModal="isShowingDetailModal"
      :isLoading="isLoading"
      title="Song Details"
      @toggleModal="isShowingDetailModal = !isShowingDetailModal"
    >
      <template slot="body" >
        <SongDetail :toggle-reset="isShowingDetailModal" :song="song"></SongDetail>
      </template>
    </ModalDialogDetail>
    <ModalDialog
      ref="submissionRejection"
      :isShowingModal="isShowingModalReject"
      :isLoading="isLoading"
      :error="isError"
      labelSubmit="Submit Rejection"
      title="Reject Submission"
      @toggleModal="isShowingModalReject=!isShowingModalReject"
      @save="submitRejected()"
    >
      <template slot="body">
        <RejectionForm ref="songRejectionForm" :toggle-reset="isShowingModalReject"
                       :filter="filter" :song-rejection="songRejection"
                       @on-submit-rejection="onSubmitRejectionForm"
        ></RejectionForm>
      </template>
    </ModalDialog>
    <ModalDialogDetail
      ref="songNote"
      :isShowingModal="isShowingModalNote"
      title="Rejection Note"
      @toggleModal="isShowingModalNote = false"
    >
      <template slot="body" >
        <div class="flex flex-col w-full py-4">
          <form-item label='Artist Name'>
            <template v-slot>
              <p class="text-left font-bold">{{ songRejectionNote.artist }}</p>
            </template>
          </form-item>
          <form-item label='Song Name'>
            <template v-slot>
              <p class="text-left font-bold">{{ songRejectionNote.title }}</p>
            </template>
          </form-item>
          <form-item label='Song Description'>
            <template v-slot>
              <p class="text-left font-bold">{{ songRejectionNote.description }}</p>
            </template>
          </form-item>
          <form-item label='Rejection Note'>
            <template v-slot>
              <p class="text-left font-bold">{{ songRejectionNote.note }}</p>
            </template>
          </form-item>
        </div>
      </template>
    </ModalDialogDetail>
    <ModalDialog
      ref="addTags"
      :isShowingModal="isShowingModalTags"
      :isLoading="isLoading"
      :error="isError"
      labelSubmit="Save"
      title="Add Tags"
      @toggleModal="isShowingModalTags=false"
      @save="submitTags()"
    >
      <template slot="body">
        <div class="w-full py-4" >
          <form-item label='Tags'>
            <el-select
              class="w-full"
              v-model="tagsValue"
              multiple
              filterable
              remote
              allow-create
              default-first-option
              reserve-keyword
              size="large"
              placeholder="Please enter a keyword"
              :remote-method="searchTags"
              :loading="loadingTags">
              <el-option
                v-for="item in tagsOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </form-item>
        </div>
      </template>
    </ModalDialog>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required, numeric, decimal, maxLength } from 'vuelidate/lib/validators';
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import ModalDialog from '@/components/Common/ModalDialog';
import ModalDialogDetail from '@/components/Common/ModalDialogDetail';
import RejectionForm from './RejectionForm';
import Vue from 'vue';
import clevertap from 'clevertap-web-sdk';
import * as moment from 'moment';
import AddSong from './AddSong';
import EditSong from './EditSong';
import SongDetail from './SongDetail';
import { Button, FormItem, TextArea } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';

const API_URL = process.env.API_URL;

export default {
  name: 'SongPage',
  mixins: [validationMixin],
  data() {
    return {
      isLoading: false,
      isEditMode: false,
      isShowingModal: false,
      isShowingDetailModal: false,
      isShowingModalReject: false,
      isSongHasBeenPublished: false,
      isShowingModalEditSong: false,
      isShowingModalNote: false,
      isShowingModalTags: false,
      isError: false,
      isEmptyMonetize: false,
      disabledIsFree: false,
      disabledIsPaid: false,
      disabledIsSubscription: false,
      disabledIsFreeUpdate: false,
      disabledIsPaidUpdate: false,
      disabledIsSubscriptionUpdate: false,
      listGenre: [],
      filterStatus: 0,
      song: {
        cover: '',
        title: '',
        genre: '',
        year: '',
        file: '',
        language: '',
        copyright: '',
      },
      songRejection: {
        id: '',
        note: '',
      },
      songTags: {
        id: '',
        tags: '',
      },
      tagsValue: [],
      tagsOption: [],
      loadingTags: false,
      songRejectionNote: {
        id: '',
        artist: '',
        title: '',
        description: '',
        note: '',
      },
      filter: {
        status: 0,
        page: 1,
        per_page: 6,
        sortby: 'submission_date',
        sortorder: 'desc',
        q: '',
        u: '',
      },
      data: [],
      total: 0,
      progressbar: 0,
      filters: '',
      filterName: '',
      selectedRow: [],
      isFileLarge: false,
      isFileWrongFormat: false,
      isPublishedSong: false,
      isFileMusicNotMP3: false,
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListGenreSong();
    const sortby = 'id';
    const sortorder = (!this.isArtist) ? 'asc' : 'desc';
    this.filter = Object.assign(this.filter, { sortby, sortorder });
    await this.requestListSong(this.filter);
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isArtist', 'isFinance', 'isOps', 'isReviewer', 'isRecruitment', 'getUser']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('SongModule', [
      'listSong',
      'getPercentageUpload',
      'listGenreSong',
      'countWaitingForReview',
      'countUnderReview',
      'countApproved',
      'countRejected',
      'countPublished',
    ]),
    titles() {
      return !this.isArtist ? [{
        prop: {
          field: 'title',
          width: 'auto',
        },
        label: 'Song Name',
      }, {
        prop: {
          field: 'artist',
          width: '150px',
        },
        label: 'Artist Name',
      }, {
        prop: {
          field: 'status',
          width: '100px',
        },
        label: 'Status',
      }] :
        [{
          prop: {
            field: 'title',
            width: 'auto',
          },
          label: 'Song Name',
        }, {
          prop: {
            field: 'genre',
            width: '130px',
          },
          label: 'Category',
        }, {
          prop: {
            field: 'year',
            width: '90px',
          },
          label: 'Year',
        }, {
          prop: {
            field: 'status',
            width: '100px',
          },
          label: 'Status',
        }];
    },
    messagePublished() {
      return this.isPublishedSong ? 'Song has been published.' : 'Song has been unpublished.';
    },
    optionTable() {
      return this.isAdmin ? 'Change Status' : 'Options';
    },
  },
  watch: {
    getPercentageUpload: {
      immediate: true,
      handler(val) {
        if (val !== 0) {
          this.progressbar = val;
        }
      },
    },
    getLoading: {
      immediate: true,
      handler(val) {
        this.isLoading = val;
      },
    },
    listSong: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
    filterStatus: {
      immediate: true,
      async handler(newval, oldval) {
        if (typeof (oldval) === 'undefined') return;
        if (newval !== oldval) {
          if (newval == 0) {
            const sortby = 'id';
            const sortorder = (!this.isArtist) ? 'asc' : 'desc';
            this.filter = Object.assign(this.filter, { sortby, sortorder });
          } else {
            const sortby = 'status_updated_at';
            const sortorder = 'desc';
            this.filter = Object.assign(this.filter, { sortby, sortorder });
          }
          await this.requestListSong(Object.assign(this.filter, { status: newval }));
        }
      },
    },
  },
  methods: {
    ...mapActions('SongModule', [
      'requestListSong',
      'requestAddSubmissionFreeSong',
      'requestListGenreSong',
      'requestDetailSubmission',
      'requestSubmitSubmissionProcess',
      'requestSubmitSubmissionPublish',
      'requestSubmitSubmissionUnpublish',
      'requestUpdateSubmissionSong',
      'requestUpdateAlbumOnly',
      'requestDeleteSubmission',
      'requestGetTags',
      'requestSaveTags',
    ]),
    ...mapActions('AuthModule', [
      'requestDetailUser',
    ]),
    toggleAction(event) {
      let popupaction = event.srcElement.closest('.container-action').children[1];
      if (popupaction == null) {
        popupaction = event.srcElement.closest('.container-action').children[0];
      }
      popupaction.classList.toggle('hidden');
    },
    async detail(event, row) {
      this.toggleAction(event);
      let dataDetail;
      if (!this.isArtist) {
        try {
          dataDetail = await this.requestDetailSubmission(row.id);
          dataDetail = dataDetail[0];
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
      } else {
        dataDetail = Object.assign({}, row);
      }
      this.song = dataDetail;
      this.song.isFree = !!(!dataDetail.is_paid && !dataDetail.is_subscription);
      this.song.isPaid = !!parseInt(dataDetail.is_paid);
      this.song.isSubscription = !!parseInt(dataDetail.is_subscription);
      this.isShowingDetailModal = !this.isShowingDetailModal;
    },
    edit(event, row) {
      this.toggleAction(event);
      this.song = row;
      this.isShowingModalEditSong = true;
    },
    deleteSong(event, row) {
      this.toggleAction(event);
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete song: ${row.title}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          const submissionData = {
            id: !this.isArtist ? row.id : row.content_id,
          };
          await this.requestDeleteSubmission({ submissionData, filter: this.filter });
          this.$swal('Deleted', 'You successfully deleted this song', 'success');
          // await this.requestDeleteAlbum({id:album.id});
        }
      });
    },
    toggleDetailModal() {
      this.isShowingDetailModal = !this.isShowingDetailModal;
      this.song = Object.assign({}, {
        cover: '',
        title: '',
        genre: '',
        year: '',
        file: '',
        isFree: false,
        isPaid: false,
        isSubscription: false,
      });
    },
    async refineData() {
      if (this.listSong.length !== 0) {
        this.total = this.listSong.total;
        if (typeof (this.listSong.data) === 'undefined') return;
        this.data = await Promise.all(this.listSong.data.map(async (song) => {
          let status = '';
          switch (song.status) {
            case 1:
              status = 'Under Review';
              break;
            case 2:
              status = 'Approved';
              break;
            case 3:
              status = 'Rejected';
              break;
            case 4:
              status = 'Published';
              break;
            // eslint-disable-next-line no-fallthrough
            case 0:
            default:
              status = 'Waiting for Review';
              break;
          }
          const file = await this.getMusicFile(song.file);
          const canDelete = song.published !== 1;
          return Object.assign(
            {},
            song,
            {
              status,
              statusCode: song.status,
              album: '-',
              file,
              elapsed_day: `${song.elapsed_day} ${song.elapsed_day > 1 ? 'days' : 'day'}`,
              canDelete,
            },
          );
        }));
      }
    },
    async submit() {
      await this.$refs.addSongContent.submit();
    },
    async submitEdit() {
      await this.$refs.editSongContent.submit();
    },
    async onSubmitSong(state) {
      this.isShowingModal = false;
      await this.searchMusic();
    },
    async onSubmitEditSong(state) {
      this.isShowingModalEditSong = false;
      await this.searchMusic();
    },
    async submitUnderReview(event, row) {
      this.toggleAction(event);
      try {
        const submissionData = {
          id: row.id,
          status: 1,
        };
        await this.requestSubmitSubmissionProcess({ submissionData, filter: this.filter });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    async submitRejected() {
      await this.$refs.songRejectionForm.submitRejection();
    },
    onSubmitRejectionForm(state) {
      this.isShowingModalReject = false;
    },
    async submitApproved(event, row) {
      this.toggleAction(event);
      try {
        const submissionData = {
          id: row.id,
          status: 2,
        };
        await this.requestSubmitSubmissionProcess({ submissionData, filter: this.filter });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    async changeAlbumOnly(row) {
      try {
        const song = {
          content_id: row.content_id,
          is_album_only: row.is_album_only ? 1 : 0,
        };

        await this.requestUpdateAlbumOnly({ song, filter: this.filter });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    async submitPublished(row) {
      try {
        const submissionData = {
          id: row.id,
        };
        if (row.published) {
          await this.requestSubmitSubmissionPublish({ submissionData, filter: this.filter });
          this.isPublishedSong = true;
        } else {
          await this.requestSubmitSubmissionUnpublish({ submissionData, filter: this.filter });
          this.isPublishedSong = false;
        }
        this.isSongHasBeenPublished = true;
        setTimeout(this.toggleToast, 2000);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    isEligibleUnderReview(row) {
      return (!this.isArtist && !this.isFinance && !this.isRecruitment) && row.statusCode === 0;
    },
    isEligibleRejected(row) {
      return (!this.isArtist && !this.isFinance && !this.isRecruitment) && row.statusCode === 1;
    },
    isEligibleApproved(row) {
      return (!this.isArtist && !this.isFinance && !this.isRecruitment) && row.statusCode === 1;
    },
    isEligiblePublished(row) {
      return (!this.isArtist && !this.isFinance && !this.isReviewer) && row.statusCode === 2;
    },
    async searchMusic() {
      await this.requestListSong(
        Object.assign(this.filter, { q: this.filters, u: this.filterName }),
      );
    },
    async resetMusic() {
      this.$refs.tableSong.$refs.elTable.clearSort();
      this.filters = '';
      this.searchMusic();
    },
    async getMusicFile(file) {
      const hostname = file.indexOf('//') > -1 ? `https://${file.split('/')[2]}` : file.split('/')[0];
      const fileAudio = await axios({
        method: 'get',
        url: file.replace(hostname, API_URL),
      });
      return fileAudio.data;
    },
    showingRejectModal(event, song) {
      this.isShowingModalReject = true;
      this.toggleAction(event);
      this.songRejection = song;
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'ascending' || typeof (queryInfo.sort.order) === 'undefined' ? 'desc' : 'asc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      if (!this.isArtist) {
        if (this.filterStatus == 0) {
          sortby = 'id';
          sortorder = 'asc';
        } else {
          sortby = 'status_updated_at';
          sortorder = 'desc';
        }
      }
      this.filter = Object.assign(this.filter, { sortorder, sortby, page });
      await this.requestListSong(this.filter);
    },
    isRejected(status) {
      return status === 3;
    },
    isApproved(status) {
      return status === 2;
    },
    toggleToast() {
      this.isSongHasBeenPublished = !this.isSongHasBeenPublished;
    },
    viewNote(row) {
      this.songRejectionNote = row;
      this.isShowingModalNote = true;
    },
    addTags(row) {
      this.songTags = row;
      if (this.songTags.tags) {
        this.tagsValue = this.songTags.tags.split(',');
      } else {
        this.tagsValue = [];
      }

      this.isShowingModalTags = true;
    },
    async searchTags(query) {
      if (query !== '') {
        this.loadingTags = true;
        const tags = await this.requestGetTags({ q: query });
        this.loadingTags = false;
        this.tagsOption = tags.map(item => ({ value: item.name, label: item.name }));
      } else {
        this.tagsOption = [];
      }
    },
    async submitTags() {
      let tags = '';
      this.tagsValue.forEach((t) => {
        if (t !== '') {
          tags += `${t},`;
        }
      });
      if (tags !== '') {
        tags = tags.substr(0, tags.length - 1);
      }
      await this.requestSaveTags({
        data: {
          music_id: this.songTags.music_id,
          tag: tags,
        },
        filter: this.filter });
      this.isShowingModalTags = false;
    },
  },
  components: {
    ModalDialog,
    ModalDialogDetail,
    RejectionForm,
    AddSong,
    EditSong,
    SongDetail,
    Button,
    Card,
    FormItem,
    TextArea
  },
};
</script>
<style scoped>
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #48bb78;
}
</style>



// WEBPACK FOOTER //
// src/views/contents/SongManagement.vue